import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import App from './App'
import './css/style.scss'
import { persistor, store } from './pages/redux/store'
import reportWebVitals from './reportWebVitals'
// import { RouterProvider } from 'react-router-dom';
// import router from './router/index';
// import Header from './components/Header';
const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.Fragment>
    {/* <RouterProvider router={router}>
      <Header> */}
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
    {/* </Header>
    </RouterProvider> */}
  </React.Fragment>
)

reportWebVitals()
